module.exports = __webpack_public_path__ + "static/media/txyinlian@2x.dec4806e.png";